module.exports = __webpack_public_path__ + "static/media/rubik-v9-latin-300.73ce1e5f.woff";